import { Component, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PackingOrderService } from '../../services/packing-order.service';
import { PackingOrder } from '../../models/entities/packing-order';
import { Location } from '@angular/common';
import { PackingOrderProduct } from '../../models/entities/packing-order-product';
 

@Component({
    selector: 'packing-order-list-mobile',
    templateUrl: './packing-order-list-mobile.component.html',
    styleUrls: ['./packing-order-list-mobile.component.scss']
})

export class PackingOrderListMobileComponent implements OnInit {

  constructor(
    protected packingOrderService : PackingOrderService,
    protected toastr              : ToastrService,
    protected location            : Location
    ) {
  }

  packingOrders     : PackingOrder[] = [];
  packingOrder      : PackingOrder;


  //------------------------------------------------------------------------------------------------------------------------
    ngOnInit(){
      let branchId       : number;
      let productId      : number;
      let startDate      : Date; 
      let endDate        : Date;
      let includeOpened  : boolean;
      let includeClosed  : boolean = false;


      this.packingOrderService.packingOrdersGet( 
        branchId       ,
        productId      ,
        startDate      ,
        endDate        ,
        includeOpened  ,
        includeClosed  ).then(result => {
          this.packingOrders = result;
      })
      
    }
  //------------------------------------------------------------------------------------------------------------------------


  //------------------------------------------------------------------------------------------------------------------------
    selectRow(packingOrder : PackingOrder){
      this.packingOrderService.packingOrderGet(packingOrder.id).then(result => {
          this.packingOrder = result;
      })
  }
  //---------------------------------------------------------------------------------------------------------------


  //---------------------------------------------------------------------------------------------------------------
    packCode  : string = null;
    quantity  : number = null;
    processPack(packingOrderProduct : PackingOrderProduct){
      this.packingOrderService.addPackToPackingOrderProduct(packingOrderProduct.id, this.packCode, this.quantity).then(packingOrderProductPack => {
        this.packCode = null;
        this.quantity = null;
        packingOrderProduct.packingOrderProductPacks.push(packingOrderProductPack);
        packingOrderProduct.packingOrderProductPacks = [...packingOrderProduct.packingOrderProductPacks];
      })
    }
  //---------------------------------------------------------------------------------------------------------------


  //------------------------------------------------------------------------------------------------------------------------
    close(){
      if (this.packingOrder) {
        this.packingOrder = null;
        return;
      }
      this.location.back();
    }
  //------------------------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------------------------
    selectPackingOrderProduct(packingOrderProduct : PackingOrderProduct){
      for (let tmp of this.packingOrder.packingOrderProducts){
        tmp.selected = false;
      }
      packingOrderProduct.selected = true;
    }
  //------------------------------------------------------------------------------------------------------------------------
  
}
